import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { UploadCloud, Loader2 } from 'lucide-react'

// Vùng kéo-thả file tái sử dụng cho mọi loại thẻ.
interface Props {
  accept?: Record<string, string[]>
  onFile: (file: File) => void
  label?: string
  hint?: string
  busy?: boolean
}

const FileDropzone: React.FC<Props> = ({ accept, onFile, label = 'Kéo-thả hoặc bấm để chọn file', hint, busy }) => {
  const onDrop = useCallback(
    (files: File[]) => {
      if (files && files[0]) onFile(files[0])
    },
    [onFile]
  )
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept, multiple: false })

  return (
    <div
      {...getRootProps()}
      className={`flex flex-col items-center justify-center gap-2 p-5 rounded-xl border-2 border-dashed cursor-pointer transition-colors ${
        isDragActive ? 'border-blue-400 bg-blue-50' : 'border-gray-200 hover:border-blue-300 hover:bg-gray-50'
      }`}
    >
      <input {...getInputProps()} />
      {busy ? <Loader2 className="w-6 h-6 text-blue-500 animate-spin" /> : <UploadCloud className="w-6 h-6 text-gray-400" />}
      <p className="text-sm font-semibold text-gray-600">{busy ? 'Đang xử lý...' : label}</p>
      {hint && <p className="text-[11px] text-gray-400">{hint}</p>}
    </div>
  )
}

export default FileDropzone
